import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

const SchemaCaptura = Yup.object({
    //numero: Yup.number('No se permiten letras').required("El número es requerido.").min(1, "El número no debe ser menor de 0").max(999, "El número maximo no pude ser mayor de 1000"),
    numero:Yup.string().required('El numero es requerido').min(2, 'Deben ser mas de un numero'),
    cantidad: Yup.number('No se permiten letras').required("La cantidad es requerida."),
    referencia: Yup.string().required('La referencia es requerida')
});

export default function Formtalonera(props) {
    const { Tiposorteo, Captura, Addcaptura } = props;
    function handlefocus(e) {
        e.target.select();
    }


    return (
        <Formik
            initialValues={
                Captura
            }
            validationSchema={SchemaCaptura}
            enableReinitialize="true"
            onSubmit={(values, actions) => {
                Addcaptura(values, actions);
                //alert('submit')
                //Save(values, actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <form onSubmit={handleSubmit}>
                    <div className='row'>
                        <div className='col-3'>
                            <input type="number" autoComplete="none" className="form-control" placeholder='$' name='cantidad' id='cantidad' value={values.cantidad || ''} onChange={handleChange}  />
                        </div>
                        <div className='col-4'>
                            <input type="text" onFocus={handlefocus} className='form-control' placeholder='Nombre' name='referencia' id='referencia' value={values.referencia || ''} onChange={handleChange} autoComplete="none" />
                        </div>
                        <div className='col-3'>
                            <input type="text" maxLength={3} className='form-control numeric' placeholder='000' name='numero' id='numero' value={values.numero || ''} onChange={handleChange} autoComplete="none" />
                            
                        </div>
                        <div className='col-2'>
                            <button type='submit' className={`btn btn-sm ${Tiposorteo ? 'btn-primary' : 'btn-success'}`} style={{ marginTop: '3px' }} ><i className="fas fa-check"></i></button>
                        </div>
                        {
                            Object.keys(errors).length > 0 &&
                            <div className='col-12'>
                                Complete los campos del formulario
                            </div>
                        }
                    </div>
                </form>
            }
        </Formik>

    )
}
